// extracted by mini-css-extract-plugin
module.exports = {"comp":"ListB1_comp__DOMHk"};